import { flow } from '../../../../../../util/flow';
import { bilibili } from './bilibili';
import { ixigua } from './ixigua';
import { prezi } from './prezi';
import { qq } from './qq';
import { vimeo } from './vimeo';
import { youku } from './youku';
import { youtube } from './youtube';

export const embedVideoHandler = flow(bilibili, ixigua, youku, qq, vimeo, youtube, prezi);
